import React from "react";
import { Text, View, StyleSheet, Image, Font } from "@react-pdf/renderer";
import snapshotImg360 from "../../Assets/Images/snapshotImg360.png";
const LatoRegular = require("../../Assets/Fonts/Lato-Font/Lato-Regular.ttf");
const LatoBold = require("../../Assets/Fonts/Lato-Font/Lato-Bold.ttf");

Font.register({
  family: "Lato",
  fonts: [
    { src: LatoRegular, fontWeight: 400 },
    { src: LatoBold, fontWeight: 700 },
  ],
});

const styles = StyleSheet.create({
  coverSection: {
    margin: "5px",
    padding: "5px",
    textAlign: "left",
    display: "flex",
    alignItems: "flex-start",
    fontFamily: "Lato",
  },
  secondsection: {
    marginTop: "10px",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    fontFamily: "Lato",
    color: "#426B88",
    fontSize: "12px",
    lineHeight: "18px",
    fontFamily: "Lato",
    fontWeight: 700,
    marginBottom: "5%",
  },
  subtitle: {
    fontSize: "24px",
    lineHeight: "18px",
    fontFamily: "Lato",
    fontWeight: "700",
    color: "#426B88",
    justifyContent: "flex-start",
    display: "flex",
  },
  section: {
    marginTop: "10px",
    textAlign: "left",
    marginLeft: "auto",
    marginRight: "auto",
  },
  paragraph: {
    fontFamily: "Lato",
    fontWeight: "400",
    fontSize: "12px",
    lineHeight: "18px",
    color: "#245775",
    textAlign: "justify",
  },
  image: {
    width: "100%",
    maxWidth: "600px",
    marginTop: "20px",
    alignSelf: "center",
  },
});

export default function AboutReportSecond360() {
  return (
    <View style={styles.coverSection}>
      <View style={styles.secondsection}>
        <Text style={styles.subtitle}>QF - 360 SNAPSHOT RESULTS</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.paragraph}>
          Your Quadrant Flow offers a structured analysis of your life and
          leadership, grounded in standardized testing. These insights are
          invaluable for navigating decisions, career planning, and personal
          growth.
        </Text>
      </View>
      <View>
        <Image src={snapshotImg360} style={styles.image} />
      </View>
    </View>
  );
}
